// Map an internal role string ("Admin", "Supervisor", "Employee", "Accountant")
// to the friendly label we show in the UI. The mapping mirrors the role-picker
// dropdown in create-user/mainUser.jsx so labels stay consistent across the app.
// Returns the original string for any unmapped value so we never silently drop
// information.
const ROLE_LABEL_MAP = {
  Admin: "Team Lead",
  Supervisor: "Client Care",
  Employee: "Agent",
  Accountant: "Accountant",
};

export function roleLabel(role) {
  if (!role) return "";
  return ROLE_LABEL_MAP[role] || role;
}

// Reaction key (singular) → denormalized count field (plural) on the post.
export const REACTION_COUNT_KEYS = {
  like: "likes",
  dislike: "dislikes",
  heart: "hearts",
  party: "party",
};

export const EMPTY_REACTION_COUNTS = {
  likes: 0,
  dislikes: 0,
  hearts: 0,
  party: 0,
};

// Pure reaction toggle math, Firestore-independent so it's easy to unit test.
// prev: reaction key | null  — the user's current reaction on this post
// incoming: reaction key      — the reaction they just clicked
// Returns { newReaction, deltas } where deltas is keyed by count field.
export function computeNewReactionState(prev, incoming) {
  const ck = (k) => REACTION_COUNT_KEYS[k];
  if (prev === incoming) {
    return { newReaction: null, deltas: { [ck(incoming)]: -1 } };
  }
  if (prev === null) {
    return { newReaction: incoming, deltas: { [ck(incoming)]: 1 } };
  }
  return { newReaction: incoming, deltas: { [ck(prev)]: -1, [ck(incoming)]: 1 } };
}

// Apply count deltas to an existing (possibly partial) counts map.
// Returns a complete counts map with all four keys, clamped at 0.
export function applyReactionDeltas(counts, deltas) {
  const result = { ...EMPTY_REACTION_COUNTS, ...(counts || {}) };
  for (const [key, delta] of Object.entries(deltas || {})) {
    result[key] = Math.max(0, (result[key] || 0) + delta);
  }
  return result;
}
